import PropTypes from "prop-types";
import { Box, Stack, Grid, useTheme, styled, Typography } from "@mui/material";
import _ from "lodash";

import { getLicenseTypeName, formatDate } from "utils";

const LicenseInfoTitle = styled(Typography)(() => ({
  font: "normal normal normal 14px/28px Ubuntu",
  color: "#FFFFFF",
  opacity: 0.8,
}));
const LicenseInfoContent = styled(Typography)(() => ({
  font: "normal normal bold 16px/28px Ubuntu",
  letterSpacing: "0px",
  color: "#FFFFFF",
}));

export const ConfirmLicenseInfo = ({ state }) => {
  const theme = useTheme();
  const { licenseInfo } = state;
  return (
    <Box
      sx={{
        marginTop: theme.spacing(3),
      }}
    >
      <Stack
        sx={{
          width: "70%",
          margin: "0 auto",
          pt: theme.spacing(3),
          pb: theme.spacing(3),
          pl: theme.spacing(4),
          pr: theme.spacing(4),
          background: "#7E55FF 0% 0% no-repeat padding-box",
          border: "2px solid #FFFFFF",
          borderRadius: "10px",
          boxShadow: "3px 3px #CDC4FA",
        }}
      >
        <Grid container>
          <Grid item xs={4}>
            <LicenseInfoTitle>License Key</LicenseInfoTitle>
          </Grid>
          <Grid item xs={8}>
            <LicenseInfoContent>
              {_.get(licenseInfo, "licenseKey")}
            </LicenseInfoContent>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            <LicenseInfoTitle>License Type</LicenseInfoTitle>
          </Grid>
          <Grid item xs={8}>
            <LicenseInfoContent>
              {getLicenseTypeName(_.get(licenseInfo, "licenseTypeId"))}
            </LicenseInfoContent>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            <LicenseInfoTitle>Seats</LicenseInfoTitle>
          </Grid>
          <Grid item xs={8}>
            <LicenseInfoContent>
              {_.get(licenseInfo, "seat")}
            </LicenseInfoContent>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            <LicenseInfoTitle>Expiration Date</LicenseInfoTitle>
          </Grid>
          <Grid item xs={8}>
            <LicenseInfoContent>
              {formatDate(_.get(licenseInfo, "validEnd"))}
            </LicenseInfoContent>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};
ConfirmLicenseInfo.propTypes = {
  state: PropTypes.object.isRequired,
};
export default ConfirmLicenseInfo;
